"use client";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/redux/store";
import { HeadModule } from "@/layouts/styles/ssr.style";
import CardBook from "@/components/card-book";
import React, { useEffect } from "react";
import { Pagination } from "antd";
import { definitions } from "@/services/metruyenvl";
import { getAllBooksRead, getAllBooksReading } from "@/redux/reducers/user.reducer";
import bookmarkAPI from "@/services/bookmark_api";
import readAPI from "@/services/read_api";
import CardBookReadings from "./card-book-reading";
import { useAuth } from "@/hooks";

function CabinetStory({ user }: { user: definitions["do.UserDO"] }) {
    const dispatch = useDispatch<AppDispatch>();
    const { userInfo } = useAuth();
    const listBookmarked: definitions["do.BookmarksByRes"] = useSelector((state: RootState) => state.userReducer.listBookmarks);
    const listReadings = useSelector((state: RootState) => state.userReducer.listReading);
    useEffect(() => {
        dispatch(getAllBooksReading({ userID: user.id as string, offset: 0, limit: 20 }));
        dispatch(getAllBooksRead({ userID: user.id as string, offset: 0, limit: 20 }));
    }, [dispatch, user]);
    const removeBookmark = async (id?: string) => {
        try {
            const res = await bookmarkAPI.delete(id ?? "");

            await dispatch(getAllBooksRead({ userID: user.id as string, offset: 0, limit: 20 }));
        } catch (error) {
            console.log(error);
        }
    };
    const removeReadings = async (id?: string) => {
        try {
            const res = await readAPI.delete(id ?? "");
            await dispatch(getAllBooksReading({ userID: user.id as string, offset: 0, limit: 20 }));
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <div>
            <HeadModule>Truyện đánh dấu</HeadModule>
            {listBookmarked?.book?.map((book, index) => {
                return (
                    <div key={index} className="mb-4">
                        <CardBook
                            book={book as definitions["do.BookDO"]}
                            isDelete={user?.id == userInfo.id ? true : false}
                            deleteFunc={() => {
                                removeBookmark(book.id);
                            }}
                        />
                    </div>
                );
            })}
            <HeadModule>Truyện đã đọc</HeadModule>
            {listReadings.map((book: any) => {
                return (
                    <div key={book.id} className="mb-4">
                        <CardBookReadings
                            chapter={book.chapter as definitions["do.ChapterDetailRes"]}
                            book={book as definitions["do.BookDO"]}
                            isDelete={user?.id == userInfo.id ? true : false}
                            deleteFunc={() => {
                                removeReadings(book.id);
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
}

export default CabinetStory;
